import Card from 'components/ui/card';

/** Coleção sem selos (SEL-09). Sem o próximo ciclo, "nos vemos no próximo ciclo". */
export default function ColecaoVazia({ proximoCiclo }: { proximoCiclo?: string }) {
  return (
    <Card padded={false} className="px-6 py-7 text-center">
      <p className="m-0 text-[15px] leading-normal text-content">
        Você ainda não conquistou selos no #JogaJunto. Não se preocupe, nos vemos no{' '}
        {proximoCiclo ? `ciclo ${proximoCiclo}` : 'próximo ciclo'}.<span aria-hidden="true"> #AGenteTemOrgulhoDeVocê</span>
        <span className="sr-only"> A gente tem orgulho de você</span>
      </p>
    </Card>
  );
}
